export default "__VITE_ASSET__BCKxcmoF__"